export const VIDEO_PLAYER = 'episode_player'
export const VIDEO_PLAYER_ID = `#${VIDEO_PLAYER}`
